import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { JwtDecoder } from "../../Utils/JwtDecoder";
import { toast } from "react-toastify";
import axios from "axios";
import base_url from "../../Utils/server";

export const UpdateProfile = () => {
  let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  console.log(currentUser)
  const mypassfeature = [
    "Minimun length should be 8 characters",
    "Must include one Lower & Uppercase Alphabets",
    "Must include one special character",
  ];
  const myuserfnamefeature = [
    "Must include only Lowercase, Uppercase Alphabets and whitespaces",
  ];
  const navigate = useNavigate();
  const Token = sessionStorage.getItem("jwtToken");
  //userfull match
  const userfullmatch = (na) => {return( /^[A-Za-z\s]*$/.test(na))};
  //has number
  const hasNumber = (number) => new RegExp(/[0-9]/).test(number);
  // has mix of small and capitals
  const hasSmall = (number) => new RegExp(/[a-z]/).test(number);
  const hasCapital = (number) => new RegExp(/[A-Z]/).test(number);
  // has special chars
  const hasSpecial = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);
  const [length, setLength] = useState(0);
  useEffect(() => {
    const passwordInput = document.getElementById("updpassword");
    const updateLength = () => {
      setLength(passwordInput.value.length);
    };
    passwordInput.addEventListener("input", updateLength);
    return () => {
      passwordInput.removeEventListener("input", updateLength);
    };
  }, []);
  // set color based on password strength
  const strengthColor = (count) => {
    if (count < 2) return { label: "Poor", color: "Red" };
    if (count < 3) return { label: "Weak", color: "yellow" };
    if (count < 4) return { label: "Normal", color: "dark-yellow" };
    if (count < 5) return { label: "Good", color: "Green" };
    if (count < 6) return { label: "Strong", color: "DarkGreen" };
    return { label: "Poor", color: "Red" };
  };
  function passwordStrength(e) {
    let password = document.getElementById("updpassword").value;
    if (length > 0) {
      let colorDiv = document.getElementById("passwordStrengthColor");
      let Strength = document.getElementById("passwordStrengthValue");
      let count = strengthIndicator(password);
      let obj = strengthColor(count);
      colorDiv.style.backgroundColor = obj.color;
      Strength.innerHTML = `${obj.label}`;
    }
    const { name, value } = e.target;
    if(password==""){
      password="null";
    }
    setInitialData((prevFormData) => {
      return {
        ...prevFormData,
        userPassword:password
      };
    });
  }
  // password strength indicator
  const strengthIndicator = (number) => {
    let strengths = 0;
    if (number.length > 7) strengths += 1;
    if (hasNumber(number)) strengths += 1;
    if (hasSpecial(number)) strengths += 1;
    if (hasCapital(number)) strengths += 1;
    if (hasSmall(number)) strengths += 1;
    if (number.length < 8) strengths = 1;
    return strengths;
  };

  function ConfirmPassword() {
    if (
      document.getElementById("updpassword").value !==
        document.getElementById("updconfirm_password").value ||
      document.getElementById("updpassword").value === ""
    ) {
      document
        .getElementById("updconfirm_password")
        .classList.add("focus:border-red-600");
      document
        .getElementById("updconfirm_password")
        .classList.remove("focus:border-green-600");
    } else {
      document
        .getElementById("updconfirm_password")
        .classList.add("focus:border-green-600");
      document
        .getElementById("updconfirm_password")
        .classList.remove("focus:border-red-600");
    }
  }
  const [initialData, setInitialData] = useState({
    userName: currentUser.userName,
    userFullName: currentUser.userFullName,
    email: currentUser.email,
    city: currentUser.city,
    dob: currentUser.dob,
    gender: currentUser.gender,
    role: currentUser.role,
    userPassword:"null"
  });
  function handleChange(e) {
    const { name, value } = e.target;
    setInitialData((prevFormData) => {
      return {
        ...prevFormData,
        [name]: value,
      };
    });
  }
  function handleinfoupd(e) {
    let updnm = document.getElementById("updnm").value;
    let upddb = document.getElementById("upddb").value;
    let updct = document.getElementById("updct").value;
    let mynewd = "";
    if (upddb != "") {
      let myd = upddb.replace(/-/g, "/");
      let mydarr = myd.split("/");
      mynewd = mydarr[2] + "/" + mydarr[1] + "/" + mydarr[0];
    }
    let updgn = document.getElementById("updgn").value;
    let updfn = document.getElementById("updfn");
    let updpassword = document.getElementById("updpassword").value;
    let updconfirm_password = document.getElementById("updconfirm_password");
    let updform = document.getElementById("updform");
    const id = toast.loading("Updating Info...", {
      position: toast.POSITION.TOP_RIGHT,
    });
    if(updpassword!="" &&(!hasNumber(updpassword) || !hasSmall(updpassword) || !hasCapital(updpassword) || !hasSpecial(updpassword) ||  updpassword.length<8) ){
      toast.update(id, {
        render: "Password doesn't match the specified criterion",
        type: "error",
        isLoading: false,
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1500);
      return;
    }
    if (updpassword != updconfirm_password.value) {
      toast.update(id, {
        render: "Passwords do not match.",
        type: "error",
        isLoading: false,
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
      return;
    }
    if(!userfullmatch(updnm) && updnm.length>0 ){
      toast.update(id, {
        render: "User Name doesn't match the specified criterion",
        type: "error",
        isLoading: false,
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
      return;
    }
    const formData1 = new FormData();
    if (updfn.files[0]) {
      formData1.append("file", updfn.files[0] || null);
    } else {
      formData1.append("file", null);
    }
    formData1.append("user", JSON.stringify(initialData));
    axios
      .post(`${base_url}/user/update`, formData1, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          setTimeout(
            function () {
              toast.update(id, {
                render: "Info Updated Successfully",
                type: "success",
                isLoading: false,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
            },
            [700]
          );
          let myfg=initialData;
          if (updfn.files[0]) {
            myfg.profileImage=res.data.data[0].profileImage;
          } else {
            myfg.profileImage=currentUser.profileImage;
          }
          delete myfg.userPassword;
          sessionStorage.setItem("currentUser", JSON.stringify(myfg));
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          setTimeout(
            function () {
              toast.update(id, {
                render: res.data.message,
                type: "error",
                isLoading: false,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              });
            },
            [500]
          );
        }
      })
      .catch((e) => {
        console.log(e);
        setTimeout(
          function () {
            toast.update(id, {
              render: "Network Error",
              type: "error",
              isLoading: false,
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            });
          },
          [500]
        );
      });
    let colorDiv = document.getElementById("passwordStrengthColor");
    let Strength = document.getElementById("passwordStrengthValue");
    if (colorDiv) {
      colorDiv.style.display = "none";
    }
    if (Strength) {
      Strength.style.display = "none";
    }
  }
  return (
    <div className="relative">
      <button
        onClick={() => {
          navigate("/profile");
        }}
        className="ml-1 absolute mt-6 fixed top-0 left-10 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
      >
        Back to Profile
      </button>
      <div className="w-4/5 absolute left-0 right-0 mx-auto border-2 mt-20 rounded-xl">
        <h3 className="mt-4 text-primary-600 text-center text-3xl font-semibold sm:text-4xl">
          Update Your Info
        </h3>
        <div className="relative overflow-y-auto p-4">
          <form
            onSubmit={(e) => e.preventDefault()}
            id="updform"
            className="space-y-4 m-8"
          >
            <div>
              <label className="text-blue-400 font-medium">Full name</label>
              <input
                type="text"
                required
                pattern="^[A-Za-z\s]+$"
                name="userFullName"
                onChange={handleChange}
                value={initialData.userFullName}
                id="updnm"
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
              />
            </div>
            <ul>
              {myuserfnamefeature.map((featureItem, idx) => (
                <li
                  key={idx}
                  className="flex items-center gap-1 text-gray-500 text-xs"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3 w-3 text-indigo-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  {featureItem}
                </li>
              ))}
            </ul>
            <div>
              <label className="text-blue-400 font-medium">Date of birth</label>
              <input
                type="date"
                required
                onChange={handleChange}
                value={initialData.dob}
                name="dob"
                id="upddb"
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
              />
            </div>
            <div>
              <label className="text-blue-400 font-medium">City</label>
              <input
                type="text"
                required
                pattern="^[A-Za-z\s]+$"
                value={initialData.city}
                onChange={handleChange}
                name="city"
                id="updct"
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
              />
            </div>
            <div>
              <label className="text-blue-400 font-medium">Gender</label>
              <input
                type="text"
                required
                pattern="^[A-Za-z\s]+$"
                onChange={handleChange}
                value={initialData.gender}
                name="gender"
                id="updgn"
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
              />
            </div>
            <div>
              <label className="text-blue-400 font-medium">Profile Image</label>
              <input
                type="file"
                name="profileImage"
                id="updfn"
                accept="image/jpeg, image/png, image/gif,image/jpg,image/bmp"
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
              />
            </div>
            <div>
              <label className="text-blue-400 font-medium">Password</label>
              <input
                type="password"
                required
                id="updpassword"
                name="userPassword"
                pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?!.*[\s\t]).{8,20}$"
                onChange={passwordStrength}
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
              />
              <div className="flex justify-between">
                <ul className="py-3 space-y-1">
                  {mypassfeature.map((featureItem, idx) => (
                    <li
                      key={idx}
                      className="flex items-center gap-1 text-gray-500 text-xs"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3 w-3 text-indigo-600"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      {featureItem}
                    </li>
                  ))}
                </ul>
                {length > 0 && (
                  <div className="flex items-center gap-3 m-1">
                    <div
                      className="font-small"
                      id="passwordStrengthValue"
                    ></div>
                    <div
                      className="h-2 w-20 rounded-lg"
                      id="passwordStrengthColor"
                    ></div>
                  </div>
                )}
              </div>
            </div>
            <div>
              <label className="text-blue-400 font-medium">
                Confirm Password
              </label>
              <input
                type="password"
                required
                id="updconfirm_password"
                name="Password"
                pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?!.*[\s\t]).{8,20}$"
                onChange={ConfirmPassword}
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border  shadow-sm rounded-lg"
              />
            </div>

            <div className="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">
              <button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleinfoupd(e);
                }}
                className="ml-1 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
